import {
  MicrophoneDeviceInfo, useMediaDevice, useMeeting
} from "@videosdk.live/react-sdk";
import { useState } from "react";
import {
  Button, Space, Tooltip, Popover, Typography
} from "antd";
import {
  DownOutlined, AudioOutlined, AudioMutedOutlined
} from "@ant-design/icons";
import {
  PlaybackDeviceInfo
} from "@videosdk.live/react-sdk/dist/types/deviceInfo";
import { useTranslation } from "react-i18next";
import useVideoStore from "../../../hooks/useVideoStore";

const { Title } = Typography;

const MicButton = () => {
  const { t } = useTranslation();
  const {
    selectedMic,
    setSelectedMic,
    selectedSpeaker,
    setSelectedSpeaker,
    isMicrophonePermissionAllowed
  } = useVideoStore();

  const {
    getMicrophones, getPlaybackDevices
  } = useMediaDevice();

  const mMeeting = useMeeting();
  const [mics, setMics] = useState<MicrophoneDeviceInfo[]>([]);
  const [speakers, setSpeakers] = useState<PlaybackDeviceInfo[]>([]);
  const localMicOn = mMeeting?.localMicOn;
  const changeMic = mMeeting?.changeMic;

  const getMics = async () => {
    const microphones = await getMicrophones();
    const sprks = await getPlaybackDevices();

    if (microphones && microphones?.length) setMics(microphones);
    if (sprks && sprks?.length) setSpeakers(sprks);
  };

  return (
    <Space.Compact>
      <Tooltip title={!isMicrophonePermissionAllowed ? t("video.accessDenied") : t("video.toggleMic")}>
        <Button
          type={localMicOn ? "primary" : "default"}
          size="large"
          icon={localMicOn ? <AudioOutlined /> : <AudioMutedOutlined/>}
          onClick={() => mMeeting.toggleMic()}
          disabled={!isMicrophonePermissionAllowed}
        />
      </Tooltip>
      <Popover
        content={(
          <Space direction="vertical" size={0}>
            <Title level={5}>{t("video.microphone")}</Title>
            {mics.map(({ deviceId, label }, index) => (
              <Button
                key={`mics_${deviceId}`}
                type={deviceId === selectedMic.id ? "primary" : "text"}
                onClick={() => {
                  setSelectedMic({ id: deviceId });
                  changeMic(deviceId);
                }}
                block
                style={{ textAlign: "left" }}
              >
                {label || `Mic ${index + 1}`}
              </Button>
            ))}
            <Title level={5}>{t("video.speaker")}</Title>
            {speakers.map(({ deviceId, label }, index) => (
              <Button
                key={`speakers_${deviceId}`}
                type={deviceId === selectedSpeaker.id ? "primary" : "text"}
                onClick={() => {
                  setSelectedSpeaker({ id: deviceId });
                }}
                block
              >
                {label || `Speaker ${index + 1}`}
              </Button>
            ))}
          </Space>
            )}
        trigger="click"
        placement="topLeft"
      >
        <Tooltip title={!isMicrophonePermissionAllowed ? t("video.accessDenied") : t("video.changeMic")}>
          <Button
            type={localMicOn ? "primary" : "default"}
            size="large"
            icon={<DownOutlined />}
            disabled={!isMicrophonePermissionAllowed}
            onClick={() => getMics()}
          />
        </Tooltip>
      </Popover>
    </Space.Compact>
  );
};

export default MicButton;
